import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=5b5b5ef8&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=5b5b5ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b5ef8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b5b5ef8')) {
      api.createRecord('5b5b5ef8', component.options)
    } else {
      api.reload('5b5b5ef8', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=5b5b5ef8&scoped=true&", function () {
      api.rerender('5b5b5ef8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-40IcAaI6eSUNO/JS/comp/PopupDialog.vue"
export default component.exports